/** @file Converts the /settings/ui wire shape into the frozen SettingsSlice (null tables become []). */
import type { UiSettings } from '../../api/apiTypes';
import type { SettingsSlice } from '../../stores/types';

/** `layout` stays as stored (null = default layout); `shortcuts: null` means no user overrides. */
export function toSettingsSlice(ui: UiSettings): SettingsSlice {
  return { lang: ui.lang, layout: ui.layout ?? null, shortcuts: ui.shortcuts ?? [] };
}
